import { FormUtils } from '../../../utils'
import { VariantFormData } from './types'

export type VariantValidation = FormUtils.FormValidation<VariantFormData>

const validator: FormUtils.DataValidatorFn<VariantFormData> = (key, value, data) => {
    switch (key) {
        case 'class': {
            if (typeof value !== 'string' || value.trim().length === 0) {
                return 'variant-validation-class'
            }
            return
        }
        case 'priority': {
            if (typeof value !== 'number' || Number.isNaN(value)) {
                return 'variant-validation-priority'
            }
            return
        }
        case 'start_date':
        case 'end_date': {
            if (value && data.end_date < data.start_date) {
                return 'variant-validation-date-end-switched'
            }
            return
        }
        default:
            return
    }
}

function validateCreation(variantData: VariantFormData) {
    return FormUtils.validate(variantData, validator)
}

function validateUpdate(variantData: VariantFormData) {
    return FormUtils.validate(variantData, validator)
}

export { validateCreation, validateUpdate }
